const { isWashStatus } = require("./controller/isWashStatus");
const { isSequential } = require("./controller/isSequential");
const { recommendSingleVehicleForOrder } = require("./recommendSingleVehicleForOrder");
const {recommendMultipleVehiclesForOrder}=require('./recommendMultipleVehiclesForOrder');
const { haversineDistance } = require("./haversineDistance");
const { isVehicleSuitableForOrder } = require("./controller/isVehicleSuitableForOrder");
const { calculateDistancePriority } = require("./calculator/calculateDistancePriority");
const { calculateCustomerPriority } = require("./calculator/calculateCustomerPriority");
const { calculateEquipmentScore } = require("./calculator/calculateEquipmentScore");
const { updateVehicleAvailability } = require("./tools/updateVehicleAvailability");
const { isVehicleSuitableForOrderDetail } = require("./controller/isVehicleSuitableForOrderDetail");
const { getVehicleInventoryMap } = require("./helpers/getVehicleInventoryMap");
const { getCustomerExpectedProducts } = require("../detailData");



/**
 * Sipariş için en uygun araç veya araçları önerir.
 * SABİT KATMAN - Bu fonksiyon her zaman vehicles'dan envanter bilgisini otomatik çıkarır
 * ve müşteri beklenen ürünleri otomatik yükler
 * @param {Object} order - Sipariş detayları.
 * @param {Array} vehicles - Araçlar listesi (inventory bilgisi içermeli).
 * @param {Array} products - Ürünler listesi.
 * @param {Array} customers - Müşteriler listesi.
 * @returns {Array} Önerilen araç veya araçlar listesi.
 */
async function recommendVehicleForOrder(
  order,
  vehicles,
  products,
  customers,
  totalCount,
  token = null,
  customerExpectedProductsParam = null,
  forceRefreshCache = false
) {
  // SABİT KATMAN 1: vehicles'dan envanter haritasını otomatik oluştur
  const vehicleInventories = getVehicleInventoryMap(vehicles);


  // SABİT KATMAN 2: Müşteri beklenen ürünlerini otomatik yükle (eğer sağlanmadıysa)
  let customerExpectedProducts = customerExpectedProductsParam;

  if (!customerExpectedProducts && token) {
    try {
      // forceRefreshCache parametresini getCustomerExpectedProducts'a geçir
      customerExpectedProducts = await getCustomerExpectedProducts(token, forceRefreshCache);
    } catch (error) {
      console.error("Müşteri beklenen ürünler yüklenemedi:", error);
      customerExpectedProducts = {};
    }
  } else {
  }

  if (!customerExpectedProducts) {
    customerExpectedProducts = {};
  }
  if (order.tonnage <= 30) {
    const vehicle = await recommendSingleVehicleForOrder(
      order,
      vehicles,
      customers,
      products,
      totalCount,
      false, // isBulk
      false, // skipTheTonnage
      true,  // setAvailable
      [],    // blockedVehicles
      false, // isClose
      token,
      customerExpectedProducts,
      vehicleInventories // Artık sabit katmandan geliyor
    );
    if (vehicle) return [vehicle];
    else return [];
  } else {
    const recommendedVehicles = await recommendMultipleVehiclesForOrder(
      order,
      vehicles,
      customers,
      products,
      totalCount,
      '',
      false, // isBulk
      false, // skipTheTonnage
      true,  // setAvailable
      [],    // blockedVehicles
      false, // isClose
      token,
      customerExpectedProducts,
      vehicleInventories // Artık sabit katmandan geliyor
    );

    return recommendedVehicles;
  }
}

const {
  isVehicleAvailableForTimeSlot,
  calculateEstimatedEndTime,
  filterAvailableVehicles,
  getReservationConflictInfo
} = require("./controller/isVehicleAvailableForTimeSlot");

module.exports = {
  isWashStatus,
  isSequential,
  recommendSingleVehicleForOrder,
  recommendVehicleForOrder,
  recommendMultipleVehiclesForOrder,
  haversineDistance,
  isVehicleSuitableForOrder,
  calculateDistancePriority,
  calculateCustomerPriority,
  calculateEquipmentScore,
  updateVehicleAvailability,
  isVehicleSuitableForOrderDetail,
  // Rezervasyon zaman kontrol fonksiyonları
  isVehicleAvailableForTimeSlot,
  calculateEstimatedEndTime,
  filterAvailableVehicles,
  getReservationConflictInfo,
};
